export default __webpack_public_path__ + "static/media/logo-2.1396e496.png";